import { useState } from "react";
import { Input } from "@chakra-ui/react";
import { t } from "i18next";
import * as React from "react";
import { useAsyncDebounce } from "../../../utils";

function InputFilter({ column, filterObj, setFilterObj }) {
  const { id } = column;
  const [value, setValue] = useState(column?.getFilterValue?.() ?? filterObj[id]);

  const delayFiltering = useAsyncDebounce((value) => {
    column?.setFilterValue?.(value || undefined);
    if (setFilterObj) {
      setFilterObj({
        attribute: id,
        value: value
      });
    }
  }, 500);

  return (
    <Input
      value={value || ""}
      onChange={(e) => {
        // Taking care of showing immediately the symbols that user enters in filter field
        setValue(e.target.value);

        // Sending the filter request to the server, but delayed with 500 ms (after the last keystroke)
        delayFiltering(e.target.value);
      }}
      placeholder={t("buttons.searchPlaceholder")}
      style={{ marginTop: "10px" }}
      borderRadius="none"
      borderColor="gray.200"
    />
  );
}

export default InputFilter;